
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-07 14:56:35
-->
<template>
   <div :style="{height:height}" class="box-style">
     <designProcess  :selectGroupItem="selectGroupItem" :heightTwo="heightTwo"></designProcess>
   </div>
</template>

<script>
import designProcess from './design_process.vue';
export default {
  data() {
    return {
      height:0,
      heightTwo:0,
      isShow:false,
    };
  },
  props: {
    selectGroupItem:{
      type:Object,
      default:{},
    }
  },
  components:{
      designProcess
  },
  mounted() {
       this.height = (document.documentElement.clientHeight - 230) + 'px';
       this.heightTwo = (document.documentElement.clientHeight - 270);
        window.onresize = () => {
            return (() => {
               this.height = (document.documentElement.clientHeight - 230) + 'px';
               this.heightTwo = (document.documentElement.clientHeight - 270);
            })();
          };
  },
  watch: {},
  methods: {
    
  },
  created() {},
};
</script>

<style lang="less" scoped>
  .box-style{
    background-color:#F1F3F5;
    height: 100%;
    margin-top: 7px;
    padding: 20px;
    padding-left: 54px;
  }
</style>